<template>
    <UiHeader v-if="showHeaderAndFooter" />
    <main>
        <slot />
        <ShopwareSideCart v-if="showHeaderAndFooter" />
    </main>
    <ScrollToTop v-if="showHeaderAndFooter" />
    <LazyUiFooter :siteConfig="siteConfig" v-if="showHeaderAndFooter" />
</template>

<script setup lang="ts">
    const siteConfig = await useSiteSettings();
    provide('siteSettings', siteConfig);
    useSiteSchema(siteConfig?.[0]);
    const route = useRoute();

    // Computed property to ensure consistent server/client evaluation
    const isCheckoutPage = computed(() => {
        // Use path instead of route.name for more reliable detection
        return route.path === '/checkout' || route.path.startsWith('/checkout/');
    });

    const isOrderFailedPage = computed(() => {
        return route.path === '/order/failed';
    });

    const showHeaderAndFooter = computed(() => {
        if (isCheckoutPage.value) {
            return false;
        }

        if (isOrderFailedPage.value) {
            return false;
        }

        return true;
    });
</script>
